import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Href } from "../../constants";
import { ContainerClassMap, HeaderClassMap } from "../../data/layout/Header";
import { useAppSelector } from "../../reduxToolkit/hooks";
import UsePathName from "../../utils/UsePathName";
import Navigation from "./navigation";
import TopBar from "./TopBar";
import Location from "./location";
import UserActions from "./userActions";

const Header = () => {
  const [Path] = UsePathName();

  const { sidebarOpen } = useAppSelector((state) => state.layout);

  const isJobOrProperty = ["job-2", "job-3", "property-2"].some((item) => Path?.includes(item));
  const isTopBar = ["car-2", "property-2"].some((item) => Path?.includes(item));

  return (
    <header className={`px-0${HeaderClassMap[Path || ""] || ""}`} id="header">
      {isTopBar && <TopBar part={Path} />}
      <Container className={ContainerClassMap[Path || ""] || ""}>
        <div className="header-flex">
          <Location part={Path} isJobOrProperty={isJobOrProperty} />
          <Navigation />
          <UserActions part={Path} isJobOrProperty={isJobOrProperty} />
        </div>
      </Container>
      <Link to={Href} className={`overlay${sidebarOpen ? " overlay--active" : ""}`} />
    </header>
  );
};

export default Header;
